import { changeView } from '../../actions/view';
import { TokenExpiredErrorView } from './TokenExpiredErrorView';
import { EActiveView } from '../../..';
import { connect } from 'react-redux';
import { sourceSelector } from '../../selectors/source';
export function mapDispatchToProps(dispatch) {
  return {
    changeViewToPhoneAuth: function changeViewToPhoneAuth() {
      dispatch(changeView(EActiveView.PhoneAuth));
    }
  };
}
function mapStateToProps(state) {
  return {
    source: sourceSelector(state)
  };
}
export var TokenExpiredErrorViewContainer = connect(mapStateToProps, mapDispatchToProps)(TokenExpiredErrorView);